module.exports = __webpack_public_path__ + "static/media/logo-ministerio-fazenda.b998a6d5.png";